<!--
 * @Author: your name
 * @Date: 2020-08-28 09:04:02
 * @LastEditTime: 2020-09-07 15:39:17
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/pay/component/Status/index.vue
-->
<style scoped lang="sass">
.status
  color: #fff
  padding: 0 10px
  height: 18px
  line-height: 18px
  border-radius: 10px
  font-weight: 300
.order_received
  background: rgba(51, 68, 85, 0.51)
.preparing
  background: rgba(242, 171, 40, 1)
.served
  background: rgba(23, 163, 65, 1)
.wrong
  background: rgba(251, 68, 85)
</style>

<template lang="pug">
.status.ls3(
  :class="className"
) {{ text }}

</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  props: {
    number: { type: Number }
  },
  computed: {
    text() {
      if (this.number === 0) {
        this.className = 'preparing'
        return 'PREPARING'
      } else if (this.number === 1) {
        this.className = 'preparing'
        return 'PREPARING'
      } else if (this.number === 2) {
        this.className = 'served'
        return 'SERVED'
      } else {
        this.className = 'wrong'
        return 'NO STATUS'
      }
    }
  }
})
class Status extends Vue {
  className = ''
}

export default Status
</script>
